enum AppRouteEnum {
    Aida = 'aida',
    Login = 'login',
}

export default AppRouteEnum;
